import { useEffect } from 'react'
import { useAppStore } from '~/lib/store'
import { DocsSidebar } from './DocsSidebar'

interface DocsLayoutProps {
    children: React.ReactNode
}

export function DocsLayout({ children }: DocsLayoutProps) {
    const { docTree, fetchDocTree } = useAppStore()

    useEffect(() => {
        if (!docTree) {
            fetchDocTree()
        }
    }, [docTree, fetchDocTree])

    return (
        <div className="flex h-full overflow-hidden">
            {/* Docs Sidebar - independent scroll */}
            <aside className="w-72 flex-shrink-0 bg-slate-800/50 border-r border-slate-700 flex flex-col h-full overflow-hidden">
                {/* Sidebar Header - fixed at top */}
                <div className="px-4 py-3 border-b border-slate-700 flex-shrink-0">
                    <h2 className="text-sm font-semibold text-white">Documentation</h2>
                    {docTree?.description && (
                        <p className="text-xs text-slate-400 mt-1">{docTree.description}</p>
                    )}
                </div>

                {/* Sidebar Content - scrollable */}
                <div className="flex-1 overflow-y-auto overflow-x-hidden">
                    {docTree ? (
                        <DocsSidebar sections={docTree.sections} />
                    ) : (
                        <div className="flex-1 flex items-center justify-center p-4">
                            <div className="text-slate-400 text-sm">Loading...</div>
                        </div>
                    )}
                </div>
            </aside>

            {/* Main Content - child controls its own scroll */}
            <main className="flex-1 h-full overflow-hidden">
                {children}
            </main>
        </div>
    )
}

